export default "/fonts/iconly.svg?94a041fbe2b39664df4126ee42702a5c";